import { useState, useEffect } from 'react';
import { searchCertifications } from '../services/content/certificationService';
import type { LMSAssociation } from '../types/content/badge';

interface LookupItem {
  id: string;
  name: string;
}

/**
 * Fetches lookup data for a given association type and returns
 * a list of items and a name resolver function.
 */
export function useAssociationLookup() {
  const [certifications, setCertifications] = useState<LookupItem[]>([]);

  useEffect(() => {
    searchCertifications({}, { pageSize: 200, orderBy: 'name', order: 'asc' })
      .then((items) => setCertifications(items.map((c) => ({ id: c.id, name: c.name }))))
      .catch(() => {});
  }, []);

  function resolveAssociationName(association: LMSAssociation | string | null | undefined, associationId: string | null | undefined): string | null {
    if (!association || !associationId) return null;

    switch (association) {
      case 'certification': {
        const found = certifications.find((c) => c.id === associationId);
        return found?.name ?? associationId;
      }
      // Future association types can be added here
      default:
        return associationId;
    }
  }

  function getOptionsForAssociation(association: string): LookupItem[] {
    switch (association) {
      case 'certification':
        return certifications;
      // Future association types can be added here
      default:
        return [];
    }
  }

  return { resolveAssociationName, getOptionsForAssociation };
}
